import axios from 'axios'
import WeatherIconType, {getWeatherIconType} from './shared/enums/weather-icon-type'
import qs from 'qs'

const API_URL = ''

// Applied only to the order-placement calls, whose client-side double-submit
// guard depends on the promise settling. Not a global default: changing the
// behaviour of all ~48 calls belongs in its own change.
const ORDER_TIMEOUT_MS = 30000

export function fetchLoginData () {
  let url = API_URL + '/rest/customer/loginInfo'
    let data = {response: undefined, error: undefined}
  return axios({
    method: 'GET',
    url: url,
    withCredentials: true
  })
    .then(function (response) {
        // console.log("Response From Login Data", response)
      data.response = response.data
      return data
    })
    .catch(function (error) {
      console.log('failed to fetch loginData', error.response)
        data.error = error;
      return data
    })
}

export function fetchTask (taskId) {
  return axios.get(API_URL + '/rest/taskOrderModelForTask/' + taskId)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchFaqLinks () {
  return axios.get(API_URL + ' /rest/faq/categories')
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchFaqQuestions (category) {
  return axios.get(API_URL + '/rest/faq/category/' + category)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchFaqContent (subcategory) {
  return axios.get(API_URL + '/rest/faq/question/' + subcategory)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchAllFaqQuestions (category) {
  return axios.get(API_URL + '/rest/faq/allFaqQuestions/' + category)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchModules (addressId) {
  return axios.get(API_URL + '/rest/customer/getDashboardModules/' + addressId)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchAdditionalTasks(addressId) {
  return axios.get(API_URL + '/rest/customer/getAdditionalTasksModule/' + addressId)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchJobHistory (addressId, page) {
  return axios.get(API_URL + '/rest/address/getHistory/' + addressId + '/' + page + '/30')
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchShopperBadge () {
  return axios.get(API_URL + '/shopperApproved')
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchSchedule (addressId, month, year) {
  return axios.get(API_URL + '/rest/job/scheduled/' + addressId + '/' + month + '/' + year)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchBillingHistory (dateRangeFilter, taskTypeFilter, startRange, endRange) {
  return axios.get(API_URL + '/rest/finances?filterByTaskType=' + taskTypeFilter + '&dateFilter=' + dateRangeFilter + '&rangeStart=' + startRange.month + '%2F' + startRange.day + '%2F' + startRange.year + '&rangeEnd=' + endRange.month + '%2F' + endRange.day + '%2F' + endRange.year + '&groupByTask=false')
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchAllBillingHistory (dateRangeFilter, taskTypeFilter) {
  return axios.get(API_URL + '/rest/finances?filterByTaskType=' + taskTypeFilter + '&dateFilter=' + dateRangeFilter + '&groupByTask=false')
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchLatestBillingHistory () {
  return axios.get(API_URL + '/rest/finances/latest')
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchInvoice (invoiceId) {
    return axios.get(API_URL + '/rest/billing/invoice/' + invoiceId)
        .then(function(response) {
            return response.data
        })
        .catch(function(error) {
            console.log(error)
        })
}

export function fetchZoneInfo (addressId) {
  return axios.get(API_URL + '/rest/seasonality/tips/' + addressId)
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function fetchZoneTips (addressId, season) {
  return axios.get(API_URL + '/rest/seasonality/tips/' + {addressId} + '/' + {season})
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error)
    })
}

export function translateWeatherData (data) {
  try {
    let iconType = getWeatherIconType(data.currently.icon)
    return {
      iconType: iconType,
      summary: data.currently.summary,
      temp: data.currently.temperature,
      maxTemp: data.daily.data[0].temperatureMin,
      minTemp: data.daily.data[0].temperatureMax
    }
  } catch (err) {
    console.log('Unable to receive weather data', err)
    return {
      iconType: WeatherIconType.CLEAR_DAY,
      summary: 'Unavailable',
      temp: '--',
      maxTemp: '--',
      minTemp: '--'
    }
  }
}

export function getForecast (lat, lon) {
  return axios.get(API_URL + '/rest/weatherForecast?lat=' + lat + '&lon=' + lon)
    .then((response) => {
      return translateWeatherData(response.data)
    })
    .catch((error) => console.log(error))
}

export function getTipCardInformation () {
  return axios.get(API_URL + '/rest/customer/getTipInformation')
    .then((response) => {
      return response
    })
    .catch((error) => console.log(error))
}

export function fetchTasksForAddress (addressId) {
  return axios.get(API_URL + '/rest/customer/getTasksForAddress/' + addressId)
    .then(function (response) {
      return response.data
    })
    .catch((error) => console.log(error))
}

export function fetchAllCustomerTaskTypes () {
  return axios.get(API_URL + '/rest/customer/getAllCustomerTaskTypes')
    .then(function (response) {
      return response.data
    })
    .catch((error) => console.log(error))
}

export function fetchMobileTask (taskType, addressId) {
  return axios.get(API_URL + '/rest/task/price/' + taskType +'/' + addressId)
    .then(function (response) {
      return response
    })
    .catch((error) => console.log(error))
}

export function fetchTaskPrices (taskType, addressId) {
  return axios.get(API_URL + '/rest/task/price/' + taskType + '/' + addressId)
    .then(function (response) {
      return response
    })
    .catch((error) => console.log(error))
}

export function getHeapTracker () {
  let url = "/CUSTOMER-DASHBOARD/"
  return axios.get(API_URL + '/rest/isHeapActive?url=' + url)
    .then(function (response) {
      return response
    })
    .catch((error) => console.log(error))
}



//PUT

export function updateServicePlan (taskId, plan) {
  return axios.put(API_URL + '/rest/task/plan/' + taskId, qs.stringify({plan: plan}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}

export function updateFrequency (taskId, frequency) {
  return axios.put(API_URL + '/rest/task/frequency/' + taskId, qs.stringify({frequency: frequency}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}
export function updateSchedule (taskId, schedule, dayOfWeek) {
  return axios.put(API_URL + '/rest/task/schedule/' + taskId, qs.stringify({schedule: schedule, dayOfWeek: dayOfWeek}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}

export function updateTaskComments (taskId, comment) {
  return axios.put(API_URL + '/rest/task/comment/' + taskId, qs.stringify({comment: comment}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}





//POST

export function addNewProperty (propertyName, enteredAddress, cityState, fulladdress, latitude, longitude, enteredZipCode) {
  return axios.post(API_URL + '/customer/addNewCustomerProperty', qs.stringify({propertyName: propertyName, enteredAddress: enteredAddress, cityState: cityState, fulladdress: fulladdress, latitude: latitude, longitude: longitude, enteredZipCode: enteredZipCode}))
    .then(function (response) {
      // console.log(response)
      return response
    })
    .catch(function(error) {
      console.log(error)
      return 'error' 
    }) 
}

export function fetchFaqQuestion (question) {
  return axios.post(API_URL + '/rest/faq/search', qs.stringify({searchText: question}))
    .then(function (response) {
      return response
    })
    .catch((error) => console.log(error))
}

export function updateBillingInfo (profilePojo, customerId) {
  return axios.post(API_URL + '/customer/saveBillingInfo', qs.stringify({profilePojo: profilePojo, customerId: customerId}))
  .then(function (response) {
    return 'okay'
  })
  .catch((error) => console.log(error))
}

export function updateUserInfo (name, email, timezone, phone, newPassword, currentPassword) {
  return axios.post(API_URL + '/customer/saveAccountSettings', qs.stringify({name: name, loginName: email, timeZone: timezone, mobileNumber: phone, newPassword: newPassword, currentPassword: currentPassword}))
    .then(function (response) {
      return 'okay'
    })
    .catch(function (error) {
      console.log(error)
      return error.response.data
    })
}

export function createOrder (address, taskType, packageType, interval, comment) {
  return axios.post(API_URL + '/rest/customer/createOrder', qs.stringify({addressId: address, taskType: taskType, packageType: packageType, interval: interval, comment: comment}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}

export function createSeasonalCustomOrder (taskType, addressId, serviceStartDate, comment) {
  // Order placement is guarded client-side against double submission, and that
  // guard needs the promise to settle. Without a timeout a hung connection
  // leaves it pending forever and the Place Order button never recovers.
  return axios.post(API_URL + '/customer/createSeasonalCustomTask', qs.stringify({taskType: taskType, addressId: addressId, serviceStartDate: serviceStartDate, comment: comment}), {timeout: ORDER_TIMEOUT_MS})
   .then(function (response) {
    return response
   })
  .catch(function (error) {
    console.log(error)
    return error
  })
}

export function skipJob (jobId, comment,) {
  return axios.post(API_URL + '/customer/skipJob', qs.stringify({jobId: jobId, comment: comment}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}

export function completeOrder (taskId, profileId, creditCardNumber, expirationMonth, expirationYear, cvvCode, billingName ){
  return axios.post(API_URL + '/rest/customer/doCheckout', qs.stringify({taskId: taskId, profileId: profileId, creditCardNumber: creditCardNumber, expirationMonth: expirationMonth, expirationYear: expirationYear, cvvCode: cvvCode, billingName: billingName}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)
  })
}

export function acceptTask (jobId){
  return axios.post(API_URL + '/customer/acceptTaskWithoutRatingByJobId', qs.stringify({jobId: jobId}))
   .then(function (response) {
    return response
   })
  .catch(function (error) {
    console.log(error)  
    return 'error'
  })
}

export function addRatingToAcceptJob (acceptanceCode, rating, ratingComment, instructions){
  return axios.post(API_URL + '/addRatingToAcceptedJob', qs.stringify({acceptanceCode: acceptanceCode, rating: rating, ratingComment: ratingComment, instructions: instructions}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
    return 'error'
  })
}

export function addRatingToAcceptJobWithoutCode (jobId, rating, ratingComment, instructions){
  return axios.post(API_URL + '/customer/addRatingToAcceptJobWithoutCode', qs.stringify({jobId: jobId, rating: rating, ratingComment: ratingComment, instructions: instructions}))
    .then(function (response) {
      return 'okay'
    })
    .catch(function (error) {
      console.log(error)
      return 'error'
    })
}

export function rejectTask (jobId, comment, rejectReason){
  return axios.post(API_URL + '/rejectJob', qs.stringify({jobId: jobId, comment: comment, rejectReason: rejectReason}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
    return 'error'
  })
}

export function acceptProposal (customerId, taskId){
  // See createSeasonalCustomOrder: the same double-submit guard covers this
  // path, so the promise must be guaranteed to settle.
  return axios.post(API_URL + '/acceptCustomTasksForCustomer', qs.stringify({customerId: customerId, taskId: taskId}), {timeout: ORDER_TIMEOUT_MS})
   .then(function (response) {
      return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
    return 'error'
  })
}

export function rejectProposal (taskId, messageId){
  return axios.post(API_URL + '/customer/rejectProposal', qs.stringify({taskId: taskId, messageId: messageId}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
    return 'error'
  })
}


export function submitCustomTask (newTaskDescription, newTaskAddressId, newTaskContractorId, taskFrequency){
  return axios.post(API_URL + '/customTaskRequest', qs.stringify({newTaskDescription : newTaskDescription, newTaskAddressId : newTaskAddressId, newTaskContractorId: newTaskContractorId, taskFrequency: taskFrequency}))
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
  })
}

export function acceptReprice (taskId, messageId){
  return axios.post(API_URL + '/customer/acceptReprice/' + taskId + '/' + messageId)
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
  })
}

export function rejectReprice (taskId, messageId){
  return axios.post(API_URL + '/customer/rejectReprice/' + taskId + '/' + messageId)
   .then(function (response) {
    return 'okay'
   })
  .catch(function (error) {
    console.log(error)  
  })
}

export function getSalesforceChatConfig () {
  return axios.get(API_URL + '/getSalesforceChatConfig')
    .then(function (response) {
      return response.data
    })
}



// WEBPACK FOOTER //
// ./src/components/api.js